/* Namaste Restaurant — theme JS (no dependencies) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.from((r || document).querySelectorAll(s)); };

  window.NR = window.NR || {};

  /* Theme toggle */
  function setTheme(m) {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(m);
    try { localStorage.setItem('nr-theme', m); } catch (e) {}
  }
  window.NR.toggleTheme = function () {
    setTheme(document.documentElement.classList.contains('dark') ? 'light' : 'dark');
  };

  /* Header scroll */
  var hdr = $('.nr-header');
  if (hdr) {
    var onScroll = function () {
      hdr.classList.toggle('scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Toast */
  function toast(msg) {
    var t = $('#NrToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('show'); }, 1600);
  }
  window.NR.toast = toast;

  /* Money format */
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.NR_MONEY_FORMAT || '₹{{amount_no_decimals}}');
    }
    return '₹' + Math.round(cents / 100);
  }

  /* Cart API */
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }
  function addVariant(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }
  function updateLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  var drawer = $('#NrCartDrawer');
  var overlay = $('#NrCartOverlay');

  function openDrawer() {
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.NR.openCart = openDrawer;
  window.NR.closeCart = closeDrawer;

  if (overlay) overlay.addEventListener('click', closeDrawer);
  $$('[data-open-cart]').forEach(function (b) {
    b.addEventListener('click', openDrawer);
  });
  $$('[data-close-cart]').forEach(function (b) {
    b.addEventListener('click', closeDrawer);
  });

  function updateBadge(count) {
    $$('.nr-cart-badge').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'grid' : 'none';
    });
    var bar = $('#NrMobBar');
    if (bar) bar.classList.toggle('active', count > 0);
  }

  function renderCart() {
    var list = $('#NrCartList');
    var foot = $('#NrCartFoot');
    var totalEl = $('#NrCartTotal');
    if (!list) return;
    list.innerHTML = '<div class="nr-muted nr-text-center" style="padding:2rem">Loading...</div>';
    fetchCart().then(function (cart) {
      updateBadge(cart.item_count);
      var mobTotal = $('#NrMobBarTotal');
      if (mobTotal) mobTotal.textContent = formatMoney(cart.total_price);
      var mobQty = $('#NrMobBarQty');
      if (mobQty) mobQty.textContent = cart.item_count;

      if (cart.items.length === 0) {
        list.innerHTML =
          '<div class="nr-text-center" style="padding:3rem 1rem">' +
          '<div style="font-size:3rem">🛒</div>' +
          '<div class="nr-font-semibold nr-mt-3">Your cart is empty</div>' +
          '<div class="nr-muted nr-text-sm nr-mt-2">Add dishes from our menu to place an order.</div></div>';
        if (foot) foot.style.display = 'none';
        return;
      }

      list.innerHTML = cart.items.map(function (it) {
        var img = it.image
          ? it.image
              .replace('.jpg', '_120x.jpg')
              .replace('.jpeg', '_120x.jpeg')
              .replace('.png', '_120x.png')
              .replace('.webp', '_120x.webp')
          : '';
        return (
          '<div class="nr-cart-item">' +
          '<div class="nr-cart-item-img"><img src="' + img + '" alt="" loading="lazy"></div>' +
          '<div class="nr-flex-1 nr-min-w-0">' +
          '<div class="nr-flex nr-items-start nr-justify-between nr-gap-2">' +
          '<div class="nr-font-semibold nr-text-sm nr-line-clamp-2">' + it.product_title + '</div>' +
          '<button data-remove="' + it.key + '" class="nr-btn-ghost" style="padding:.25rem;height:auto;color:var(--muted-fg)" aria-label="Remove">✕</button>' +
          '</div>' +
          '<div class="nr-text-xs nr-muted nr-mt-2">' + formatMoney(it.final_price) + ' each</div>' +
          '<div class="nr-flex nr-items-center nr-justify-between nr-mt-2">' +
          '<div class="nr-qty" style="background:var(--muted);color:var(--fg)">' +
          '<button data-qty="' + it.key + '" data-delta="-1">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button data-qty="' + it.key + '" data-delta="1">+</button>' +
          '</div>' +
          '<div class="nr-font-bold">' + formatMoney(it.final_line_price) + '</div>' +
          '</div></div></div>'
        );
      }).join('');

      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      if (foot) foot.style.display = 'block';

      $$('[data-qty]', list).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.qty;
          var delta = parseInt(btn.dataset.delta, 10);
          var item = cart.items.find(function (i) { return i.key === key; });
          if (!item) return;
          var newQty = Math.max(0, item.quantity + delta);
          updateLine(key, newQty).then(renderCart);
        });
      });
      $$('[data-remove]', list).forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateLine(btn.dataset.remove, 0).then(renderCart);
        });
      });
    }).catch(function () {
      list.innerHTML = '<div class="nr-muted nr-text-center" style="padding:2rem">Could not load cart.</div>';
    });
  }

  window.NR.addToCart = function (variantId, qty, name) {
    addVariant(variantId, qty || 1)
      .then(function () {
        toast(name ? name + ' added' : 'Added to cart');
        return fetchCart();
      })
      .then(function (c) {
        updateBadge(c.item_count);
        var bar = $('#NrMobBar');
        if (bar) {
          var mobTotal = $('#NrMobBarTotal');
          if (mobTotal) mobTotal.textContent = formatMoney(c.total_price);
          var mobQty = $('#NrMobBarQty');
          if (mobQty) mobQty.textContent = c.item_count;
        }
      })
      .catch(function () {
        toast('Could not add. Try again.');
      });
  };

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add-variant]');
    if (!a) return;
    e.preventDefault();
    window.NR.addToCart(a.dataset.addVariant, 1, a.dataset.addName || '');
  });

  /* Menu filters */
  var search = $('#NrMenuSearch');
  var chips = $$('[data-chip]');
  var vegBtn = $('#NrVegOnly');
  var state = { q: '', cat: 'all', veg: false };

  function applyFilters() {
    var q = state.q.trim().toLowerCase();
    var shown = 0;
    $$('.nr-menu-group').forEach(function (group) {
      var cat = (group.dataset.cat || '').toLowerCase();
      var anyVisible = false;
      $$('.nr-pcard', group).forEach(function (card) {
        var nm = (card.dataset.name || '').toLowerCase();
        var isVeg = card.dataset.veg === 'true';
        var catOk = state.cat === 'all' || cat === state.cat.toLowerCase();
        var qOk = !q || nm.indexOf(q) !== -1 || cat.indexOf(q) !== -1;
        var vegOk = !state.veg || isVeg;
        var ok = catOk && qOk && vegOk;
        card.style.display = ok ? '' : 'none';
        if (ok) {
          anyVisible = true;
          shown++;
        }
      });
      group.style.display = anyVisible ? '' : 'none';
    });
    var empty = $('#NrMenuEmpty');
    if (empty) empty.style.display = shown === 0 ? '' : 'none';
  }

  if (search) {
    search.addEventListener('input', function (e) {
      state.q = e.target.value;
      applyFilters();
    });
  }
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chips.forEach(function (x) { x.classList.remove('active'); });
      c.classList.add('active');
      state.cat = c.dataset.chip;
      applyFilters();
    });
  });
  if (vegBtn) {
    vegBtn.addEventListener('click', function () {
      state.veg = !state.veg;
      vegBtn.classList.toggle('active', state.veg);
      vegBtn.style.background = state.veg ? '#16a34a' : '';
      vegBtn.style.color = state.veg ? '#fff' : '';
      vegBtn.style.borderColor = state.veg ? '#16a34a' : '';
      applyFilters();
    });
  }

  /* Carousel */
  $$('[data-carousel]').forEach(function (car) {
    var prevBtn = car.querySelector('[data-prev]');
    var nextBtn = car.querySelector('[data-next]');
    var track = car.parentElement
      ? car.parentElement.querySelector('.nr-carousel')
      : null;
    if (!track) {
      var section = car.closest('.nr-section') || car.closest('section');
      if (section) track = section.querySelector('.nr-carousel');
    }
    if (!track) return;
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -400, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: 400, behavior: 'smooth' });
      });
    }
  });

  /* Gallery modal */
  var modal = $('#NrModal');
  var modalImg = $('#NrModalImg');
  $$('[data-gallery-img]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (modal && modalImg) {
        modalImg.src = el.dataset.galleryImg || (el.querySelector('img') && el.querySelector('img').src) || '';
        modal.classList.add('open');
      }
    });
  });
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.nr-modal-close')) {
        modal.classList.remove('open');
      }
    });
  }

  /* WhatsApp order */
  window.NR.whatsappOrder = function () {
    fetchCart()
      .then(function (cart) {
        if (cart.items.length === 0) {
          toast('Cart is empty');
          return;
        }
        var wa = (document.body.dataset.whatsapp || '').replace(/\D/g, '');
        var prefix = document.body.dataset.waPrefix || '*New Order*';
        var lines = cart.items.map(function (it, i) {
          return (i + 1) + '. ' + it.product_title + ' × ' + it.quantity + ' — ' + formatMoney(it.final_line_price);
        });
        var msg =
          prefix +
          '%0A%0A' +
          lines.join('%0A') +
          '%0A%0A*Total: ' +
          formatMoney(cart.total_price) +
          '*%0A%0A*Notes:*';
        window.open('https://wa.me/' + wa + '?text=' + msg, '_blank');
      })
      .catch(function () {
        toast('Could not open WhatsApp');
      });
  };

  /* Reservation form */
  var resForm = $('#NrReservationForm');
  var resConfirm = $('#NrResConfirm');
  var resSummary = $('#NrResSummary');

  window.NR.resetReservation = function () {
    if (resForm) resForm.style.display = '';
    if (resConfirm) resConfirm.style.display = 'none';
    if (resForm) resForm.reset();
  };

  if (resForm) {
    resForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!resForm.checkValidity()) {
        resForm.reportValidity();
        return;
      }
      var fd = new FormData(resForm);
      var d = Object.fromEntries(fd.entries());
      var wa = (document.body.dataset.whatsapp || '').replace(/\D/g, '');
      var shopName = document.body.dataset.shopName || 'Namaste Restaurant';
      var msg =
        '*New Table Reservation — ' +
        shopName +
        '*%0A%0A*Name:* ' +
        d.name +
        '%0A*Phone:* ' +
        d.phone +
        '%0A*Email:* ' +
        d.email +
        '%0A*Date:* ' +
        d.date +
        '%0A*Time:* ' +
        d.time +
        '%0A*Guests:* ' +
        d.guests +
        '%0A*Notes:* ' +
        (d.notes || '—');

      try {
        var body = new URLSearchParams({
          form_type: 'contact',
          utf8: '✓',
          'contact[name]': d.name,
          'contact[email]': d.email,
          'contact[phone]': d.phone,
          'contact[subject]': 'Table Reservation',
          'contact[body]':
            'Reservation Request\nName: ' +
            d.name +
            '\nPhone: ' +
            d.phone +
            '\nEmail: ' +
            d.email +
            '\nDate: ' +
            d.date +
            '\nTime: ' +
            d.time +
            '\nGuests: ' +
            d.guests +
            '\nNotes: ' +
            (d.notes || '-')
        });
        fetch('/contact#contact_form', { method: 'POST', body: body }).catch(function () {});
      } catch (err) {}

      if (resSummary) {
        resSummary.innerHTML =
          '<div><b>Name:</b> ' +
          d.name +
          '</div><div><b>Phone:</b> ' +
          d.phone +
          '</div><div><b>Email:</b> ' +
          d.email +
          '</div><div><b>When:</b> ' +
          d.date +
          ' at ' +
          d.time +
          '</div><div><b>Guests:</b> ' +
          d.guests +
          '</div>' +
          (d.notes ? '<div><b>Notes:</b> ' + d.notes + '</div>' : '');
      }
      resForm.style.display = 'none';
      if (resConfirm) resConfirm.style.display = 'block';
      setTimeout(function () {
        window.open('https://wa.me/' + wa + '?text=' + msg, '_blank');
      }, 300);
      toast('Reservation sent!');
    });
  }

  /* Fade-up on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('nr-fade-up');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '-40px' }
    );
    $$('[data-animate]').forEach(function (el) {
      io.observe(el);
    });
  }

  /* Init cart badge on load */
  fetchCart()
    .then(function (c) {
      updateBadge(c.item_count);
    })
    .catch(function () {});
})();
